var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{staticClass:"event-card-label",class:[
        {
            'event-card-label--live' : _vm.props.isLive,
            'event-card-label--bold' : _vm.props.isBold,
            'event-card-label--text-darker' : _vm.props.isTextDarker,
        },
        _vm.data.class,
        _vm.data.staticClass ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }